import { Box, Paper, Typography } from "@mui/material"
import ErrorIcon from "@mui/icons-material/Error"
import PrimaryButton from "../../../shared/buttons/PrimaryButton"
import useTranslation from "hooks/use_translation"
const Empty = () => {
  const { anamnesis } = useTranslation()
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        backgroundColor: "",
        borderRadius: "10px",
      }}
    >
      <Box sx={{ display: "flex", p: 2, backgroundColor: "#E0EBFF", borderRadius: "12px", mb: 2 }}>
        <ErrorIcon sx={{ width: 60, height: 60, color: "primary.main" }} />
        <Box sx={{ ml: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1 }}>
            {anamnesis?.result_unsuccess_title}
          </Typography>
          <Typography variant="subtitle2" sx={{ fontWeight: 500, lineHeight: 1, mt: 1 }}>
            {anamnesis?.result_unsuccess_subtitle}
          </Typography>
        </Box>
      </Box>

      <Typography variant="h5" sx={{ fontWeight: 700, mt: 4 }}>
        {anamnesis?.result_unsuccess_results}
      </Typography>

      <Typography sx={{ fontWeight: 600, mt: 1 }}>{anamnesis?.result_unsuccess_disease}</Typography>

      <Typography variant="body2" sx={{ mt: 2 }}>
        {anamnesis?.result_unsuccess_desc}
      </Typography>

      <PrimaryButton fullWidth text={anamnesis?.result_unsuccess_btn} href="/me" />
    </Paper>
  )
}

export default Empty
